/**
 * Refonte Achats · Stock WP-13 (A-11) — the matching constants shared by the server engine and the
 * offline store (« same algorithm offline »). Platform-governed: the server CONFIG
 * (apps/server/src/config/recherche-produit.config.js) re-exports these values and never retypes them.
 */

/** A-11 — below this many normalised characters no search runs (the client shows a hint). */
export const RECHERCHE_MIN_CARACTERES = 2;

/** At most this many distinct tokens are matched (the rest of a pasted sentence is ignored). */
export const RECHERCHE_MAX_TOKENS = 8;

/**
 * Typo tier (A-11 « trigram similarity », ux/04 §3.1 T4 « Orthographe proche »): a token with no
 * substring match still matches a word whose trigram similarity reaches this value, provided the
 * token has at least RECHERCHE_PROCHE_MIN_CARACTERES characters (DECISIONS A-43).
 */
export const RECHERCHE_SEUIL_SIMILARITE = 0.4;
export const RECHERCHE_PROCHE_MIN_CARACTERES = 4;

/**
 * Ranking tiers (A-11 refined by ux/04 §3.1): the lower, the better. The keys are the payload's
 * `pertinence.niveau` values.
 */
export const NIVEAU_PERTINENCE = Object.freeze({
  EXACT: 0, // the whole query is a barcode / N° ENR of the row (T0)
  PREFIXE_NOM: 1, // first token prefixes the nom commercial, every token prefixes a word (T1)
  PREFIXE: 2, // every token prefixes a word somewhere (T2)
  SOUS_CHAINE: 3, // every token is a substring (T3)
  PROCHE: 4, // at least one token matched by trigram similarity only (T4)
});

export const NIVEAUX_PERTINENCE = Object.freeze(Object.keys(NIVEAU_PERTINENCE));
